import * as React from 'react';
import { useEffect, useState } from 'react';
import { getFromStorage, saveToStorage } from '../lib/storage';

export function usePersistedState<T>(
  key: string,
  initialState: T,
  useTTL = false
): [state: T, setter: React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    return useTTL
      ? getFromStorage(key)
      : (JSON.parse(window.localStorage.getItem(key) as string, (k, v) =>
          k === 'password' ? atob(v) : v
        ) as T) || initialState;
  });

  useEffect(() => {
    useTTL
      ? saveToStorage(key, state)
      : window.localStorage.setItem(
          key,
          JSON.stringify(state, (k, v) => (k === 'password' ? btoa(v) : v))
        );
  }, [key, state]);

  return [state, setState];
}
